import {
  Breakpoints,
  type TagColor,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import React from 'react';

import { OrganizationType } from '../common/OrganizationImg';
import OrganizationTag, {
  type OrganizationTagDetails,
} from '../common/OrganizationTag';

import type { SchoolTagCoachFragment } from './__generated-gql-types__/SchoolTag.generated';

interface SchoolTagProps {
  coach?: SchoolTagCoachFragment;
  selectedSchoolTagDetails?: Partial<OrganizationTagDetails>;
  tagColor?: TagColor;
  className?: string;
}

const SchoolTag: React.FC<SchoolTagProps> = ({
  coach,
  selectedSchoolTagDetails,
  tagColor,
  className,
}) => {
  const isMd = useMediaQuery(Breakpoints.MD);

  const studiedAt =
    coach?.educationExperiences?.find((education) => education.isFeatured) ??
    coach?.educationExperiences?.[0];
  const organization =
    selectedSchoolTagDetails?.organization ??
    (studiedAt
      ? {
          name: studiedAt.school.name,
          logoLink: studiedAt.school.logoLink,
        }
      : null);
  const schoolTagDetails: Nullable<OrganizationTagDetails> = organization
    ? {
        organization,
        text: `${isMd ? 'Studied at ' : ''}${studiedAt?.school.name}`,
        tagColor,
        ...selectedSchoolTagDetails,
      }
    : null;

  return schoolTagDetails?.organization ? (
    <OrganizationTag
      className={className}
      tagDetails={schoolTagDetails}
      type={OrganizationType.SCHOOL}
    />
  ) : null;
};

export default SchoolTag;
